<template src="./assetcheckview.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";
  import ViewAssetChecks from "@/pages/assetchecks/assetcheckviewdata/assetcheckviewdata.vue";
  import VueHtml2pdf from "vue-html2pdf";

  export default {
    components: { ViewAssetChecks, VueHtml2pdf },
    data() {
      return {
        ShowLoader: false,
        AssetCheckSubmitId: 0,
      };
    },
    mounted() {
      this.$root.$on("GeneratePDF", () => {
        this.GeneratePDF();
      });
      var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
      );
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        FleetSubscription.fleet_modules
      );
      if(!FleetSubscriptionModules.Assets  && (!AccountPermissions.Assets || !AccountPermissions.Assets.enable)){
        this.$router.push('/');
      }
      document.title = pbx_SiteTitle + " - Assets Check View";
      this.AssetCheckSubmitId = this.$route.params.Id;
    },
    methods: {
      LoadProfileData() {
        this.GetAssetChecksList();
      },
      SearchAsset() {
        this.GetAssetChecksList();
      },
      GeneratePDF() {
        this.$refs.html2Pdf.generatePdf({ useCORS: true });
      },
      PDFDownloaded() {
        $("#save_pdf_btn").html("Save as PDF");
      },
    },
  };
</script>
